import { render, staticRenderFns } from "./PhysicianVisitsTow.vue?vue&type=template&id=6553e04c&scoped=true&"
import script from "./PhysicianVisitsTow.vue?vue&type=script&lang=js&"
export * from "./PhysicianVisitsTow.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianVisitsTow.vue?vue&type=style&index=0&id=6553e04c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553e04c",
  null
  
)

export default component.exports